module.exports = __webpack_public_path__ + "static/img/work-title.3ee2318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/work-title.png
// module id = dc05
// module chunks = 0